import { render, staticRenderFns } from "./ResourceCalendar.vue?vue&type=template&id=0ef3fc42&scoped=true&"
import script from "./ResourceCalendar.vue?vue&type=script&lang=js&"
export * from "./ResourceCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ResourceCalendar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ResourceCalendar.vue?vue&type=style&index=1&id=0ef3fc42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef3fc42",
  null
  
)

export default component.exports